export default {
    methods: {
        async reset(){
            const userID = this.$route.params.id
            await this.$store.dispatch( 'user/resetPassword', userID )
        }
    }
}
